module.exports = __webpack_public_path__ + "assets/img/shiping2.fb2770a2.png";